import * as React from 'react';
import { Accordion, Card, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { newMobileClientCheck, setQuoteType } from '../../../actions/salesActions';
import { CAR_REGISTRATION, DASHBOARD, PERSONAL_INFO } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import './GetCarInsurance.css';
import { PRODUCT_COMPREHENSIVE_CAR } from '../../../constants/constants';
import { NAM_COUNTRY_ID_NUMBER } from '../../../constants/internationalization';
import { logEvent } from '../../../firebase/firebase';

class GetCarInsurance extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            eventKey1Open: false,
            eventKey2Open: false,
            eventKey3Open: false,
            eventKey4Open: false,
            eventKey5Open: false,
            eventKey6Open: false,
            eventKey7Open: false,
            eventKey8Open: false,
            eventKey9Open: false,
            loggedIn: this.props.auth.uid ? true : false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_car_insurance_landed', 'user_landed_on_get_car_insurance');
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleShowComingSoon() {
        this.props.dispatchShowComingSoon();
    }

    async handleRedirect() {
        logEvent('SSP_get_car_insurance_add_to_quote', 'user_cliked_get_a_quote_car_insurance');
        var nextPage = PERSONAL_INFO;
        if (this.props.profile.policyId !== "") {
            nextPage = CAR_REGISTRATION;
            await this.props.dispatchSetQuoteType();
            this.props.dispatchCreditHistoryCheck();
        }
        else {
            await this.props.dispatchSetQuoteType();
            this.props.redirectTo(nextPage);
        }
    }

    handleAccordianArrow(e: any) {
        switch (e) {
            case 1:
                this.setState({ eventKey1Open: !this.state.eventKey1Open })
                this.setState({ eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 2:
                this.setState({ eventKey2Open: !this.state.eventKey2Open })
                this.setState({ eventKey1Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 3:
                this.setState({ eventKey3Open: !this.state.eventKey3Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 4:
                this.setState({ eventKey4Open: !this.state.eventKey4Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 5:
                this.setState({ eventKey5Open: !this.state.eventKey5Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 6:
                this.setState({ eventKey6Open: !this.state.eventKey6Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey7Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 7:
                this.setState({ eventKey7Open: !this.state.eventKey7Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey8Open: false, eventKey9Open: false })
                break;
            case 8:
                this.setState({ eventKey8Open: !this.state.eventKey8Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey9Open: false })
                break;
            case 9:
                this.setState({ eventKey9Open: !this.state.eventKey9Open })
                this.setState({ eventKey1Open: false, eventKey2Open: false, eventKey3Open: false, eventKey4Open: false, eventKey5Open: false, eventKey6Open: false, eventKey7Open: false, eventKey8Open: false })
                break;
            default:
        }
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        return (
            <div className={this.state.loggedIn ? "logged-in" : "logged-out"}>
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get car insurance" />
                <div className="ml-0 row">
                    <div className="col-12 col-lg-12 px-lg-3 pr-3 pl-0 mb-lg-3">
                        <div id="GetCarInsuranceBanner">
                            <div className="row">
                                <div className="col-12 col-lg-8 text-center text-lg-left border-right">
                                    <img src="./images/OnlineQuotes/CarInsurance/car-insurance.png" alt="" />
                                    <h2 className="mt-3">Car insurance</h2>
                                    {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                        <>
                                            <h4>The only car insurance premium in the world that decrease monthly</h4>
                                            <p>You know that your car loses value from day 1, right? So, why pay premiums that only ever increase? We’re the only insurer to offer premiums that decrease monthly as your car loses value. We just think it makes sense!</p>
                                        </>
                                    }
                                    <div className="text-center text-lg-left">  <button className="btn btn-solid-green mt-3 mb-2 mb-lg-5" id="get-quote-car" onClick={this.handleRedirect}>Get a quote</button></div>
                                    <hr className="d-lg-none" />
                                </div>

                                <div className="col-12 col-lg-4 text-left">
                                    <h5>The king’s benefits</h5>
                                    <div className="li-list">
                                        <ul className="the-kings-benefits">
                                            <li>{this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? 'Emergency' : 'Roadside'} assist</li>
                                            {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                                <li>Decreasing premiums</li>
                                            }
                                            <li>Quick and easy claims</li>
                                            {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                                <li>The king’s cab</li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 px-lg-3 pl-0 mb-3 mt-3 mt-lg-0">
                        <div id="OptionalExtraCover" className="mt-lg-2">
                            <h3>Optional extra cover</h3>

                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-lg-6  p-0">
                                        <div className="dot float-left"></div>
                                        <p>Car hire</p>
                                    </div>
                                    {this.props.profile.countryId !== 157 &&
                                        <div className="col-12 col-lg-6 p-0">
                                            <div className="dot float-left"></div>
                                            <p>Car warranty</p>
                                        </div>
                                    }
                                </div>
                                {this.props.profile.countryId === 157 &&
                                    <>
                                    <div className="row">
                                        <div className="col-12 col-lg-6 p-0">
                                            <div className="dot float-left"></div>
                                            <p>Credit shortfall</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 col-lg-6 p-0">
                                            <div className="dot float-left"></div>
                                            <p>Tyre and rim</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Scratch and dent</p>
                                            </div>
                                    </div>
                                </>
                                }
                                {this.props.profile.countryId !== 157 &&
                                    <>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Credit shortfall</p>
                                            </div>

                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Scratch and dent</p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Personal accident</p>
                                            </div>

                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Tyre and rim</p>
                                            </div>
                                        </div>

                                        <div className="row">

                                            <div className="col-12 col-lg-6 p-0">
                                                <div className="dot float-left"></div>
                                                <p>Sound equipment and other accessories</p>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div id="TheKingsBenefits" className="mt-3">
                            <h3>The king’s benefits</h3>

                            <div className="row border-bottom">
                                <div className="col-2">
                                    <div className="online-emergency-assist mx-auto d-block mt-5 mt-md-4 mt-lg-1"></div>
                                </div>

                                <div className="col-10">
                                    <h4>{this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? 'Emergency' : 'Roadside'} assist</h4>
                                    <p>
                                        The king has you covered. 24 hours a day, 7 days a week, 365 days a year. When you're part of our royal family, we've got your back! Whether your issue is medical, technical or domestic, you're in the king's safe hands.
                                    </p>
                                </div>
                            </div>
                            {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                <div className="row border-bottom">
                                    <div className="col-2">
                                        <div className="online-cash-gold mx-auto d-block mt-5 mt-md-4 mt-lg-3"></div>
                                    </div>

                                    <div className="col-10">
                                        <h4 className="mt-3">Decreasing premiums</h4>
                                        <p>
                                            Why keep paying the same premium to insure your car when it's only ever worth less? It doesn't make sense to us, so we employed some seriously clever people to find a way of decreasing car insurance premiums every month. It's only fair!
                                        </p>
                                    </div>
                                </div>
                            }

                            <div className={this.props.profile.countryId !== 157 ? "row border-bottom" : "row"}>
                                <div className="col-2">
                                    <div className="online-headphones-red mx-auto d-block mt-5  mt-md-4  mt-lg-3"></div>
                                </div>

                                <div className="col-10">
                                    <h4 className="mt-3">Quick and easy claims</h4>
                                    <p>
                                        If you have an accident and you're covered by the king, call our emergency assist line ASAP if you're able to. We'll organise emergency medical help, arrange to have your car towed, and tell you what you need to do.
                                    </p>
                                </div>
                            </div>
                            {this.props.profile.countryId !== 157 &&
                                <div className="row">
                                    <div className="col-2">
                                        <div className="online-kings-cab-active mx-auto d-block mt-5 mt-md-4 mt-lg-3"></div>
                                    </div>
                                    <div className="col-10">
                                        <h4 className="mt-3">The king’s cab</h4>
                                        <p>
                                            The cold ones were flowing, but now it's time to get going? We'll get you (and your car) home safely. The king's cabbies are on call when you have comprehensive car cover with the king. It's a small extra cost... For big peace-of-mind.
                                        </p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 px-lg-3 pl-0">
                        <div id="FAQGetCarInsurance" className="mt-2 mb-lg-0">
                            <h3>FAQs</h3>

                            <div className="row">

                                <div className="col-12 px-lg-3 mb-3">
                                    <div className="submit-a-claim-history-block">
                                        {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                            <div className="mt-lg-2">
                                                <Accordion>
                                                    <Card className="mb-lg-3 mb-3" >
                                                        <Accordion.Toggle as={Card.Header} eventKey="1" id="Accordian1" onClick={() => this.handleAccordianArrow(1)}>
                                                            Which car insurance is the best
                                                            <Image className={"accordian-arrow" + (this.state.eventKey1Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="1">
                                                            <Card.Body>
                                                                <p>
                                                                    The best car insurance is the kind that offers you a fair and logical cover for your car without compromising your budget. The king of price offers you quality service and super cheap car insurance premiums that decrease monthly in line with the depreciating value of your car.
                                                                </p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </div>
                                        }
                                        {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                                            <div className="mt-lg-2">
                                                <Accordion>
                                                    <Card className="mb-lg-3 mb-3" >
                                                        <Accordion.Toggle as={Card.Header} eventKey="2" id="Accordian2" onClick={() => this.handleAccordianArrow(2)}>
                                                            How can I pay less for car insurance
                                                            <Image className={"accordian-arrow" + (this.state.eventKey2Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="2">
                                                            <Card.Body>
                                                                <p>Get comprehensive car insurance from the king of price, who decreases your premium every month in line with the depreciating value of your car.</p>
                                                                <p>Insure 2+ cars with King Price and get up to 20% discount on your premium.</p>
                                                                <p>You can lower your car insurance premium by getting a quote from King Price for super cheap premiums that decrease monthly in line with the depreciating value of your car. King Price also lets you lower your premiums by increasing your excess amount, but remember that you'll have to pay this higher excess amount if you claim.</p>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </div>
                                        }

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="3" id="Accordian3" onClick={() => this.handleAccordianArrow(3)}>
                                                        Which cars have the cheapest insurance
                                                        <Image className={"accordian-arrow" + (this.state.eventKey3Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="3">
                                                        <Card.Body>
                                                            <ul>
                                                                <li>Chevrolet Aveo and Spark.</li>
                                                                <li>Nissan Micra.</li>
                                                                <li>Kia Picanto.</li>
                                                                <li>Toyota Corolla and Etios.</li>
                                                                <li>Ford Figo.</li>
                                                                <li>Nissan 1400.</li>
                                                                <li>Renault Sandero.</li>
                                                                <li>Hyundai i10 and i20.</li>
                                                            </ul>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="4" id="Accordian4" onClick={() => this.handleAccordianArrow(4)}>
                                                        How much does it cost to insure a new car
                                                        <Image className={"accordian-arrow" + (this.state.eventKey4Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="4">
                                                        <Card.Body>
                                                            <p>
                                                                The cost of insuring a new car can be more expensive than a slightly older or second-hand model. The price you pay depends entirely on the kind of car you want to insure, the insurer you choose to go with, and your personal info, like how long you've had your driver's license and how old you are.
                                                                (Are refundable, subject to the terms and conditions of the car hire service provider).
                                                            </p>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="5" id="Accordian5" onClick={() => this.handleAccordianArrow(5)}>
                                                        Do I have to have insurance to buy a car
                                                        <Image className={"accordian-arrow" + (this.state.eventKey5Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="5">
                                                        <Card.Body>
                                                            <p>
                                                                <p>You don't have to have insurance to buy a car. However, if you're taking out a loan from a bank or financing house to pay for your precious new (or new-to-you) car, then it's compulsory to get comprehensive car insurance.{this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER && " If you want super cheap cover, chat to King Price for decreasing premiums and the freedom to choose your own excess."}</p>
                                                            </p>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="6" id="Accordian6" onClick={() => this.handleAccordianArrow(6)}>
                                                        Do I need insurance to drive a used car off the lot
                                                        <Image className={"accordian-arrow" + (this.state.eventKey6Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="6">
                                                        <Card.Body>
                                                            <p>
                                                                <p>In {this.props.profile.countryId === 157 ? "Namibia" : "South Africa"}, you need insurance to drive a used car off the lot if you've financed the car. If you didn't get a loan from the bank, then you don't need insurance. But you should consider having insurance anyway, because once you drive it off the lot, you'll be responsible for any costs if you have an accident or if it's stolen.</p>
                                                            </p>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="7" id="Accordian7" onClick={() => this.handleAccordianArrow(7)}>
                                                        How do I get car insurance for the first time
                                                        <Image className={"accordian-arrow" + (this.state.eventKey7Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="7">
                                                        <Card.Body>
                                                            <p>A royal consultant will call you to ask for a few more details and make sure you understand everything about our cover.</p>
                                                            <p>Your policy will be created and your documents will be emailed or posted to you.</p>
                                                            <p>Congratulations... You now have insurance with the king of price!</p>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>

                                        <div className="mt-lg-2">
                                            <Accordion>
                                                <Card className="mb-lg-3 mb-3" >
                                                    <Accordion.Toggle as={Card.Header} eventKey="8" id="Accordian8" onClick={() => this.handleAccordianArrow(8)}>
                                                        Can I get car insurance without a driver's licence
                                                        <Image className={"accordian-arrow" + (this.state.eventKey8Open ? ' isRotated' : '')} alt="" src="./Images/emergencyassist/icons-arrow-dropdown-down-white-16-px.png"></Image>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="8">
                                                        <Card.Body>
                                                            <p> You can't get car insurance without a driver's licence in {this.props.profile.countryId === 157 ? "Namibia" : "South Africa"}. Not only is it illegal to drive a car without a licence, but the length of time that you've had your licence for, is 1 of the risk factors that determines your premium.</p>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCreditHistoryCheck: () => dispatch(newMobileClientCheck("", true, null)),
        dispatchSetQuoteType: () => dispatch(setQuoteType(PRODUCT_COMPREHENSIVE_CAR)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetCarInsurance);